export default __webpack_public_path__ + "cf7d964a45cd5b33123b8c46163a2496.gif";